import { ProductType } from '@hc-frontend/core-types';
import { useEventBus, useTrackingContexts } from '@hc-frontend/core-ui';
import { ComponentImpressionEvent } from '@hc-frontend/features-tracking';
import { useEffect } from 'react';

export function useComponentImpression(id: string) {
  const eventBus = useEventBus();
  const contexts = useTrackingContexts();

  useEffect(() => {
    eventBus.publish<ComponentImpressionEvent>({
      id,
      topic: 'core.ui.component.impression',
      source: null as never,
      componentImpression: {
        component: id,
        action: 'display',
        category: 'WIDGET',
        product: ProductType.Enum.HEALTH,
      },
      contexts,
    });
  }, [id, contexts, eventBus]);
}
